import { render } from "./SalesChart.vue?vue&type=template&id=7b0a3a02&scoped=true&ts=true"
import script from "./SalesChart.vue?vue&type=script&lang=ts"
export * from "./SalesChart.vue?vue&type=script&lang=ts"

import "./SalesChart.vue?vue&type=style&index=0&id=7b0a3a02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0a3a02"]])

export default __exports__